import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { forgotPassword } from '../api/auth';
import styles from './LoginPage.module.css';
import { useTranslation } from 'react-i18next';
import { getApiErrorMessage } from '../utils/apiError';

const ForgotPasswordPage = () => {
  const location = useLocation();
  const [email, setEmail] = useState(() => new URLSearchParams(location.search).get('email') || '');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation('auth');
  const { t: tApi } = useTranslation('apiErrors');

  const handleSubmit = async () => {
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const res = await forgotPassword(email);
      setSuccess(res?.message || t('forgotPassword.success'));
    } catch (err) {
      const msg = getApiErrorMessage(err, tApi);
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{t('forgotPassword.title')}</h2>

      {error && <p className={styles.error}>{error}</p>}
      {success && <p>{success}</p>}

      <label htmlFor="forgot-email" style={{ display: 'block', marginBottom: 4 }}>{t('forgotPassword.emailLabel')}</label>
      <input
        id="forgot-email"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={t('forgotPassword.emailPlaceholder')}
        style={{ display: 'block', marginBottom: '10px' }}
      />

      <button className={styles.loginButton} onClick={handleSubmit} disabled={loading}>
        {loading ? t('forgotPassword.sending') : t('forgotPassword.submit')}
      </button>

      <div className={styles.linkRow}>
        <Link to="/login" style={{ color: 'blue', textDecoration: 'underline' }}>
          {t('forgotPassword.backToLogin')}
        </Link>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
